import { CnpjDetail } from "@/components/CnpjDetail";
import { Button } from "@/components/ui/button";
import { UI } from "@/lib/labels";
import { ArrowLeft } from "lucide-react";
import { useLocation, useNavigate, useParams } from "react-router-dom";

interface LocationState {
  from?: string;
}

/** Página de detalhe do CNPJ (ficha completa em rota própria). */
export function CnpjDetailPage() {
  const { cnpj = "" } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const from = (location.state as LocationState | null)?.from ?? "/";
  const selfUrl = `${location.pathname}${location.search}`;

  return (
    <div className="space-y-4">
      <Button variant="ghost" onClick={() => navigate(from)}>
        <ArrowLeft className="h-4 w-4" aria-hidden="true" />
        {UI.actions.back}
      </Button>
      <CnpjDetail cnpj={cnpj} from={selfUrl} />
    </div>
  );
}
